import { createSlice } from "@reduxjs/toolkit";

const contractSlice = createSlice({
  name: "contractDetails",
  initialState: [],
  reducers: {
    setContractDetails: (_state, action) => ({
      ...action.payload,
    }),
  },
});

export const { setContractDetails } = contractSlice.actions;

export const contractDetails = contractSlice.reducer;

export default contractSlice.reducer;
